<breadcrumb endText="User Management" />
<div class="m-8 flex flex-col gap-5">
  <div>
    <h1 class="font-semibold text-xl mb-2">
      User Management
    </h1>
    <hr />
  </div>
  <div>
    @if (showAllUsers) {
    <button (click)="allUsersClick()"
      class="border rounded-2xl min-w-[196px] h-[152px] m-5 p-1.5 flex items-end justify-center float-left text-sm font-medium"
      id="allusers">
      All Users
    </button>
    }
    @if (userCreate) {
    <button (click)="addNewUser()"
      class="border rounded-2xl min-w-[196px] h-[152px] m-5 p-1.5 flex items-end justify-center text-sm font-medium float-left"
      id="createuser">
      Create a New User
    </button>
    }
    @if (userCreate) {
    <button (click)="importUsers()"
      class="border rounded-2xl min-w-[196px] h-[152px] m-5 p-1.5 flex items-end justify-center text-sm font-medium float-left"
      id="importusers">
      Import User List
    </button>
    }
    @if (roleManager) {
    <button (click)="userRolesClick()"
      class="border rounded-2xl min-w-[196px] h-[152px] m-5 p-1.5 flex items-end justify-center text-sm font-medium float-left"
      id="userroles">
      User Roles
    </button>
    }
  </div>
</div>